import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Button from '../../ui-core/Button/Button';

import { APP_ROUTES, getRoute } from '../../route';
import { CloseButton, FormControl } from 'react-bootstrap';
import { setSearchInput } from '../../store/action/search';

import './style.css';

const SearchBar = ({ history, match, redirectToSearch }) => {
  const dispatch = useDispatch();
  const keyword = match.params?.keyword;
  const inputRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!redirectToSearch) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 0);
    }
  }, [redirectToSearch, history.location.pathname]);

  const { searchInput } = useSelector(state => state.search);

  const handChange = e => {
    const value = e.target.value.trim();
    if (value.length > 2 || searchInput.length) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        if (!value.length) {
          history.push(APP_ROUTES.COLLECTION);
          return;
        }
        dispatch(setSearchInput(value));
        const url = getRoute(APP_ROUTES.SEARCH, {
          pathParam: {
            keyword: encodeURIComponent(value.replace(/[^a-zA-Z0-9 ]/g, '')), // regular expression to remove special characters
          },
        });
        if (keyword) {
          history.replace(url);
        } else {
          history.push(url);
        }
      }, 500);
    }
  };
  const handleRedirection = () => {
    if (redirectToSearch) {
      history.push(APP_ROUTES.COLLECTION);
    }
  };

  const handleRedirectToSearch = () => {
    if (searchInput.trim()) {
      const url = getRoute(APP_ROUTES.SEARCH, {
        pathParam: {
          keyword: encodeURIComponent(searchInput),
        },
      });
      const state = history.location.state;
      history.push(url, state);
    }
  };

  const handleKeyDown = event => {
    if (event.keyCode === 13) handleRedirectToSearch();
  };

  const handleClear = () => {
    inputRef.current?.focus();
    dispatch(setSearchInput(''));
    history.push(APP_ROUTES.COLLECTION);
  };

  return (
    <div
      className="header-search position-relative"
      onClick={handleRedirection}
    >
      <Button
        onClick={handleRedirectToSearch}
        variant="outline-success"
      ></Button>
      <FormControl
        ref={inputRef}
        placeholder="Search plans, exercises and quick tips"
        onChange={handChange}
        defaultValue={keyword}
        onKeyDown={handleKeyDown}
        aria-label="Search"
      />
      {keyword && (
        <CloseButton
          disabled={!keyword}
          onClick={handleClear}
          className="clear-button"
        />
      )}
    </div>
  );
};

SearchBar.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  redirectToSearch: PropTypes.bool.isRequired,
};

export default withRouter(SearchBar);
